
<collapsible-section
  :id="`step_${section.workflowStep.client_id}-${dropdownControlId}`"
  :control-name="`${section.workflowStep.titleOrDefault}Collapse`"
  :is-open="false"
>
  <template #section-header>
    {{ section.workflowStep.titleOrDefault }}
  </template>

  <template #section-contents>
    <workflow-step-data
      :q="q"
      :handler="handler"
      :parent-tree-context="parentTreeContext"
      :section="section"
      @select="select"
    />

    <section-fields
      v-if="handler.usersOnly"
      :q="q"
      :handler="handler"
      :section="handler.formWorkflowStepUserSection(section.workflowStep)"
      icon-glyph="member"
      @select="select"
      :select-additional-parameters="[handler.formUserSection(section.workflowStep).type, section.workflowStep]"
    />
  </template>
</collapsible-section>
